import { render } from "./Materiales.vue?vue&type=template&id=558df8fa&scoped=true"
import script from "./Materiales.vue?vue&type=script&lang=js"
export * from "./Materiales.vue?vue&type=script&lang=js"

import "./Materiales.vue?vue&type=style&index=0&id=558df8fa&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558df8fa"]])

export default __exports__